import { createTenantBootstrapRuntime } from "./createTenantBootstrapRuntime";

export const tenantBootstrapRuntime = createTenantBootstrapRuntime();

export const getRequiredCurrentTenantFirebase = () =>
  tenantBootstrapRuntime.getRequiredCurrentTenantFirebase();
